import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://bltfkxktwbbxuqppoyvq.supabase.co'
const supabaseKey = 'sb_publishable_glZw_VMTrIDSbS9Qa6t71A_gkGw0CYz'

export const supabase = createClient(supabaseUrl, supabaseKey)
